export const PURGE_ICON = 'fas fa-broom';
